
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRainShowersPolartwilightColour as ObiLightningLightRainShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningLightRainShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain-showers-polartwilight-colour',
   elementClass: ObiLightningLightRainShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 